import * as React from 'react'
import { Helmet } from 'react-helmet'
import { isAdmin, isProducer, isManager } from 'web-fns/dist/auth'

import NewBrandDashboard from '../BrandDashboard'

import { BrandOrders } from './BrandOrders/BrandOrders'

interface BrandDashboardTemplatesProps {
  match?: { params: { id: string } }
  searchToken?: string
}

const BrandDashboardTemplates: React.FC<BrandDashboardTemplatesProps> = ({
  match,
  searchToken,
}) => {
  const brandId = match && match.params.id

  const activeButton = isAdmin() || isProducer() || isManager() ? 2 : 1
  return (
    <>
      <Helmet>
        <title>Dashboard - 90 Seconds</title>
      </Helmet>
      <NewBrandDashboard
        brandId={brandId}
        activeButton={activeButton}
        children={<BrandOrders />}
        subHeaderTitle="Browse"
        searchToken={searchToken}
      />
    </>
  )
}

export default React.memo(BrandDashboardTemplates)



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/BrandDashboardTemplates/BrandDashboardTemplates.tsx